<template>
  <div class="aboutus">
    <div class="title">
      <el-divider content-position="center">項目經驗</el-divider>
      <!-- <p><el-tag >成都货安计量技术中心</el-tag><el-tag>自由职业</el-tag><el-tag>广州品高软件股份有限公司</el-tag></p> -->
    </div>
    <div class="experience">
      <el-timeline>
        <el-timeline-item timestamp="2019/12/-2020/01" placement="top">
          <el-card>
            <h3>项目名称:四川运营监控中心迁移</h3>
            <h5>
              技术栈:
              <el-tag>Java</el-tag>,
              <el-tag>JDK1.6</el-tag>,
              <el-tag>Tomcat</el-tag>,
              <el-tag>DB2</el-tag>,
              <el-tag>GBase</el-tag>,
              <el-tag>Datax</el-tag>
            </h5>
            <h5>项目描述:该项目是从2011年至今的一个指标分析、可视化平台，至今单季度日指标数据达8亿+记录，总记录数达200亿条，文件存储达5TB。</h5>
            <p>
              1.独立负责该项目的后端改造，使系统支持GBase，技术难点在于，无源代码，JDK版本比较老
              <br />2.独立负责大表数据迁移，小表数据采用Datax进行迁移，大数据按日数据按季度从DB2导出，使用GBase自带的远程文件Load方式。
              <br />3.独立负责处理项目安全问题
            </p>
             <el-image
              style="width: 100px; height: 100px"
              :src="monitor_project"
              :preview-src-list="monitor_projects"
            ></el-image>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2019/05-2019/08" placement="top">
          <el-card>
            <h3>项目名称:Redash BI二次开发</h3>
            <h5>
              技术栈:
              <el-tag>Python</el-tag>,
              <el-tag>PostgreSQL</el-tag>,
              <el-tag>Redis</el-tag>,
              <el-tag>Angularjs</el-tag>,
              <el-tag>Flask</el-tag>,
              <el-tag>Cerlery消息队列</el-tag>
            </h5>
            <h5>项目描述:该项目是为移动客户开发的一个用于编写脚本实现报表快速呈现的小型工具类系统</h5>
            <p>
              1.独立负责该项目的后端改造，
              <br />2.独立改造Redash前端。
              <br />3.独立部署以及后期功能新增和维护工作。
            </p>
            <el-image
              style="width: 100px; height: 100px"
              :src="redash_project"
              :preview-src-list="redash_projects"
            ></el-image>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2019/10-至今" placement="top">
          <el-card>
            <h3>项目名称:晓木木记事</h3>
            <h5>
              技术栈:
              <el-tag>Golang</el-tag>,
              <el-tag>Gin</el-tag>,
              <el-tag>PostgreSQL</el-tag>,
              <el-tag>NSQ消息队列</el-tag>,
              <el-tag>微信小程序</el-tag>,
              <el-tag>ColorUI</el-tag>,
              <el-tag>Github</el-tag>,
              <el-tag>Nginx</el-tag>
            </h5>
            <h5>项目描述:该项目为个人兴趣项目，目前已经开发四个功能，正在不断完善新功能，其由个人采用Golang语言的Gin框架开发WebApi，小程序端目前采用的是ColorUI</h5>
            <p>
              1.独立使用Gin框架开发后端接口，
              <br />2.独立使用ColorUI开发小程序端。
              <br />3.使用Nginx配置多虚拟主机。
            </p>
            <el-image
              style="width: 100px; height: 100px"
              :src="remark_project"
              :preview-src-list="remark_projects"
            ></el-image>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2019/03-2019/08" placement="top">
          <el-card>
            <h3>项目名称:小牛ERP</h3>
            <h5>
              技术栈:
              <el-tag>.net core mvc/web api</el-tag>,
              <el-tag>SQL Server</el-tag>,
              <el-tag>ABP</el-tag>,
              <el-tag>微信小程序</el-tag>,
              <el-tag>ColorUI</el-tag>,
              <el-tag>Github</el-tag>,
              <el-tag>Nginx</el-tag>
            </h5>
            <h5>项目描述:该项目是珠宝ERP，包括:采购、销售、报表、供货商管理、客户管理等功能(自己的接的私活),配有后台管理端和微信小程序端</h5>
            <p>
              1.独立使用ABP开发ERP后端管理以及WebAPI接口，
              <br />2.独立使用ColorUI开发小程序端。
              <br />3.使用Nginx配置多虚拟主机。
            </p>
            <el-image
              style="width: 100px; height: 100px"
              :src="erp_project"
              :preview-src-list="erp_projects"
            ></el-image>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2018/08-2019/05" placement="top">
          <el-card>
            <h3>项目名称:成都移动智慧场景运营平台</h3>
            <h5>
              技术栈:
              <el-tag>Java</el-tag>,
              <el-tag>Spring Boot</el-tag>,
              <el-tag>GRPC</el-tag>,
              <el-tag>DB2</el-tag>,
              <el-tag>GBase</el-tag>,
              <el-tag>MySQL</el-tag>,
              <el-tag>Dapper</el-tag>,
              <el-tag>Mybatis</el-tag>,
              <el-tag>Kettle</el-tag>,
              <el-tag>Swagger</el-tag>,
              <el-tag>LayUI</el-tag>,
              <el-tag>BUI</el-tag>,
              <el-tag>Jquery</el-tag>,
              <el-tag>.net core mvc/webapi</el-tag>,
              <el-tag>Gitlab</el-tag>,
              <el-tag>MySQL</el-tag>,
              <el-tag>Topshelf/Windows服务</el-tag>,
              <el-tag>AutoMapper</el-tag>,
              <el-tag>Autofac</el-tag> 
            </h5>
            <h5>项目描述:该项目是从2018年8月至今,一个为成都移动提供基于地图GIS网格化服务的营销服务平台。</h5>
            <p>
              1.负责技术选型和项目架构搭建，服务器环境搭建。
              <br />2.负责PC段高德地图和谷歌地图整合难点，
              <br />3.负责系统难点攻克。
              <br />4.独立开发开发手机App(Cordova)以及App后端WebAPI接口
              <br />5.工作分配以及部分资源协调
              <br />
            </p>
            <el-image
              style="width: 100px; height: 100px"
              :src="zhcj_project"
              :preview-src-list="zhcj_projects"
            ></el-image>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2017/08-2018/05" placement="top">
          <el-card>
            <h3>项目名称:四川中移在线营销支撑项目</h3>
            <h5>
              技术栈:
              <el-tag>Java</el-tag>,
              <el-tag>Spring Boot</el-tag>,
              <el-tag>Nginx</el-tag>,
              <el-tag>.Net Core</el-tag>,
              <el-tag>ABP</el-tag>,
              <el-tag>EF Core</el-tag>,
              <el-tag>Redis</el-tag>,
              <el-tag>MongoDB</el-tag>,
              <el-tag>MySQL</el-tag>,
              <el-tag>Mycat</el-tag>,
              <el-tag>Mybatis</el-tag>,
              <el-tag>H5</el-tag>,
              <el-tag>Vue</el-tag>,
              <el-tag>WebApi</el-tag>,
              <el-tag>Swagger</el-tag>,
              <el-tag>Svn</el-tag>,
              <el-tag>微信公众号</el-tag>
              
            </h5>
            <h5>项目描述:该项目是从2017年8月至2018年5月,为中移在线公司开发的营销支撑微信公众号网页项目,其中包括流量超市、活动拼团、宽带专区三个子系统，为四川中移在线带来有效的微信营销支撑。</h5>
            <p>
              1.独立负责服务器架构设计、搭建以及运维。
              <br />2.独立设计、开发微信公众号服务端Web API
              <br />3.负责项目难点攻克。
              <br />4.参与公众号前端vue开发，前端难点技术攻克
              <br />5.工作分配以及部分资源协调，
              <br />6.负责技术选型
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2015/05-至今" placement="top">
          <el-card>
            <h3>项目名称:四川移动自助取数系统</h3>
            <h5>
              技术栈:
              <el-tag>Java</el-tag>,
              <el-tag>Silverlight</el-tag>,
              <el-tag>Nginx</el-tag>,
              <el-tag>MySQL</el-tag>,
              <el-tag>DB2</el-tag>,
              <el-tag>GBase</el-tag>
            </h5>
            <h5>项目描述:该项目是从2015年至今,为四川移动开发的一个取数、分析的BI系统，为四川21个地市提供快速取数快速分析快速展示的功能支持，大大的提升各地市提数效率，节约成本，获得用户一致好评</h5>
            <p>
              1.负责系统运维、迁移。
              <br />2.负责新功能收集和开发。
              <br />3.2015年独立完成tomcat多项目拆分。
              <br />3.2018年独立完成Windows平台迁移到Linux平台并完成相关功能改造。
            </p>
            <el-image
              style="width: 100px; height: 100px"
              :src="insight_project"
              :preview-src-list="insight_projects"
            ></el-image>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2015/12-2016/06" placement="top">
          <el-card>
            <h3>项目名称:攀枝花大数据项目支撑</h3>
            <h5>
              技术栈:
              <el-tag>Java</el-tag>,
              <el-tag>Linux</el-tag>,
              <el-tag>Oracle</el-tag>,
              <el-tag>MySQL</el-tag>,
              <el-tag>DB2</el-tag>,
              <el-tag>Hive</el-tag>
            </h5>
            <h5>项目描述:该项目主要为一个服务支撑项目，主要为用户编写业务hive语句，配合ETL工具定时处理、同步数据。</h5>
            <p>
              1.独立搭建为攀枝花移动搭建公司的ETL产品并为用户培训。
              <br />2.独立为攀枝花移动编写业务hive sql。
              <br />3.独立协调公司资源配合ETL项目实施
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2015/05-2015/09" placement="top">
          <el-card>
            <h3>项目名称:成都铁路局仓储管理系统</h3>
            <h5>
              技术栈:
              <el-tag>C#</el-tag>,
              <el-tag>Oracle</el-tag>,
              <el-tag>WebService</el-tag>,
              <el-tag>Devexpress</el-tag>
            </h5>
            <h5>项目描述:该项目为成都铁路局整备车间用户管理列车物资而开发的的管理系统，由我采用C#+Devexpress独立完成及实施 </h5>
            <p>
              1.独立完成客户端开发。
              <br />2.独立完成数据库设计。
              <br />3.独立完成项目实施
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2014/10-2014/12" placement="top">
          <el-card>
            <h3>项目名称:铁二院项目管理系统</h3>
            <h5>
              技术栈:
              <el-tag>.net mvc</el-tag>,
              <el-tag>SQL Server</el-tag>,
              <el-tag>EasyUI</el-tag>,
              <el-tag>Jquery</el-tag>
            </h5>
            <h5>项目描述:该项目为中铁二院开发的权限管理、项目管理、项目进度、项目周报、员工考勤、员工工分、请假等功能的管理系统 </h5>
            <p>
              1.由我个人独立完成需求收集。
              <br />2.由我独立完成项目的设计和编码、以及后期实施及维护。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2015/03-2015/04" placement="top">
          <el-card>
            <h3>项目名称:微信支付</h3>
            <h5>
              技术栈:
              <el-tag>Java</el-tag>,
              <el-tag>微信公众号</el-tag>,
              <el-tag>微信JSSDK</el-tag>
            </h5>
            <h5>项目描述:微信刚出来时，文档并不完善，为开发带来了困难，所以手动封装了微信支付接口供某公司使用 </h5>
            <p>
              1.独立收集需求以及设计、开发和维护。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2014/03-2015/07" placement="top">
          <el-card>
            <h3>项目名称:动车工具管理系统</h3>
            <h5>
              技术栈:
              <el-tag>.net mvc</el-tag>,
              <el-tag>SQL Server</el-tag>,
              <el-tag>EasyUI</el-tag>,
              <el-tag>Jquery</el-tag>,
              <el-tag>Bootstrap</el-tag>,
            </h5>
            <h5>项目描述:传统借用工具都是手工记录方式，非常繁杂，而且容易遗失，为此开发了这款管理系统，使用二维码和RFID电子标签管理动车维修工具。 </h5>
            <p>
              1.独立收集需求以及设计、开发和维护。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2014/03-2015/07" placement="top">
          <el-card>
            <h3>项目名称:动车轮对管理系统</h3>
            <h5>
              技术栈:
              <el-tag>.net mvc</el-tag>,
              <el-tag>SQL Server</el-tag>,
              <el-tag>EasyUI</el-tag>,
              <el-tag>Jquery</el-tag>,
              <el-tag>Bootstrap</el-tag>,
            </h5>
            <h5>项目描述:传统的轮对数据是使用Execl进行计算和判断是否需要检修，面对数百列动车上千轮对，这无疑是庞大的手工工作，为此开发了该系统，自动计算轮对，自动预警等 </h5>
            <p>
              1.独立收集需求以及设计、开发和维护。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2014/03-2014/07" placement="top">
          <el-card>
            <h3>项目名称:成都移动传播资源管理系统</h3>
            <h5>
              技术栈:
              <el-tag>.net mvc</el-tag>,
              <el-tag>Oracle</el-tag>,
              <el-tag>EasyUI</el-tag>,
              <el-tag>Jquery</el-tag>,
              <el-tag>Bootstrap</el-tag>,
              <el-tag>Gis(百度地图)</el-tag>
            </h5>
            <h5>项目描述:成都移动为了方便管理、了解自己和竞争对手的广告投放而开发的基于GIS可视化展示的管理系统 </h5>
            <p>
              1.独立解决百度JSAPI离线问题。
              <br />2.负责核心功能开发。
              <br />3.独立完成项目搭建，服务器环境搭建。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2013/08-2018/02" placement="top">
          <el-card>
            <h3>项目名称:成都微区域GIS</h3>
            <h5>
              技术栈:
              <el-tag>Silverlight</el-tag>,
              <el-tag>DB2</el-tag>,
              <el-tag>Java</el-tag>,
              <el-tag>Tomcat</el-tag>,
              <el-tag>Gis(谷歌离线地图)</el-tag>
            </h5>
            <h5>项目描述:成都移动为了高效营销业务而开发的基于基站可视化展示挖掘用户数据进行精准营销,一共有五期项目 </h5>
            <p>
              1.团队协作,开发数据挖取条件配置等功能。
              <br />2.开发手机端WebApp的开发。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2014/02-2014/03" placement="top">
          <el-card>
            <h3>项目名称:成都移动自备机管理系统</h3>
            <h5>
              技术栈:
              <el-tag>.net</el-tag>,
              <el-tag>DB2</el-tag>,
              <el-tag>IIS</el-tag>,
              <el-tag>EasyUI</el-tag>,
              <el-tag>扫码枪(硬件)</el-tag>
            </h5>
            <h5>项目描述:成都移动为了高效管理各个商家的手机设备而开发的进销存管理系统 </h5>
            <p>
              1.独立收集需求，设计以及编码
              <br />2.独立负责后期新功能的开发以及运维工作。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2013/04-2013/05" placement="top">
          <el-card>
            <h3>项目名称:新津站救灾快讯</h3>
            <h5>
              技术栈:
              <el-tag>.net</el-tag>,
              <el-tag>Oracle</el-tag>,
              <el-tag>Highcharts</el-tag>,
              <el-tag>视频监控</el-tag>
            </h5>
            <h5>项目描述:该项目是由于眉山地震时，为了让铁路总公司实时查看货站救灾物资的运输情况而开发的一个监控及报表实时查看的系统，赢得了铁路总公司的高度赞赏 </h5>
            <p>
              1.独立完成highcharts图表开发
              <br />2.协助解决部署等问题。
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2011/11—2013/06" placement="top">
          <el-card>
            <h3>项目名称:成都铁路局货运信息平台</h3>
            <h5>
              技术栈:
              <el-tag>.net</el-tag>,
              <el-tag>Oracle</el-tag>,
              <el-tag>Highcharts</el-tag>,

            </h5>
            <h5>项目描述:该项目主要为收集整合成都铁路局各个车站的货运、货检等数据。是一个长期的维护开发型项目 </h5>
            <p>
              1.独立完成highcharts图表开发
              <br />2.独立完成各项报表开发(铁路这种单位报表真的是超级多)。
            </p>
          </el-card>
        </el-timeline-item>
         <el-timeline-item timestamp="2012/04—2013/06" placement="top">
          <el-card>
            <h3>项目名称:货检安全集中监控系统</h3>
            <h5>
              技术栈:
              <el-tag>Delphi</el-tag>,
              <el-tag>SQL Server</el-tag>,
              <el-tag>存储过程和触发器</el-tag>
            </h5>
            <h5>项目描述:该系统算是公司的一个货运安全监控产品，它包含超限、超偏载、轨道衡、高清视频监控等，但是由于全国不同铁路局的业务多多少少会有一些差异，所以会进行一些定制化开发。 </h5>
            <p>
              1.独立完成个性化需求开发
              <br />2.到各站实施（合肥、邯郸、德州、北京）实施系统、接口对接开发以及后期培训和维护。
            </p>
          </el-card>
        </el-timeline-item>
         <el-timeline-item timestamp="2012/04—2013/06" placement="top">
          <el-card>
            <h3>项目名称:系统接口开发</h3>
            <h5>
              技术栈:
              <el-tag>.net</el-tag>,
              <el-tag>Oracle</el-tag>
              <el-tag>XML</el-tag>
              <el-tag>Windows服务程序</el-tag>
            </h5>
            <h5>项目描述:该项目主要是为了收集各个系统数据而开发的解析接口数据文件的服务程序。 </h5>
            <p>
              1.独立开发接口解析文件服务程序
            </p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
   
  </div>
</template>

<script>
export default {
  name: "Products",
  data() {
    return {
      drawer: false,
      direction: "btt",
      currentIndex: 0,
      zhcj_project: "http://resume.52fx.biz/zhcj_project_1.png",
      zhcj_projects: [
        "http://resume.52fx.biz/zhcj_project_1.png",
        "http://resume.52fx.biz/zhcj_project_2.png",
        "http://resume.52fx.biz/zhcj_project_3.png",
        "http://resume.52fx.biz/zhcj_project_5.png"
      ],
      insight_project: "http://resume.52fx.biz/myresume_insight_1.png",
      insight_projects: [
        "http://resume.52fx.biz/myresume_insight_1.png",
        "http://resume.52fx.biz/myresume_insight_2.png",
        "http://resume.52fx.biz/myresume_insight_3.png"
      ],
      erp_project: "http://resume.52fx.biz/myresume_erp_2.jpg",
      erp_projects: [
        "http://resume.52fx.biz/myresume_erp_2.jpg",
        "http://resume.52fx.biz/myresume_erp_3.jpg",
        "http://resume.52fx.biz/myresume_erp_5.jpg",
        "http://resume.52fx.biz/myresume_erp_1.png"
      ],
      remark_project: "http://resume.52fx.biz/myresume_remark_1.jpg",
      remark_projects: [
        "http://resume.52fx.biz/myresume_remark_1.jpg",
        "http://resume.52fx.biz/myresume_remark_2.jpg",
        "http://resume.52fx.biz/myresume_remark_3.jpg"
      ],
      monitor_project: "http://resume.52fx.biz/myresume_monitor_1.png",
      monitor_projects: [
        "http://resume.52fx.biz/myresume_monitor_1.png",
        "http://resume.52fx.biz/myresume_monitor_2.png",
        "http://resume.52fx.biz/myresume_monitor_3.png"
      ],
      redash_project:"http://resume.52fx.biz/myresume_redash_2.png",
      redash_projects:["http://resume.52fx.biz/myresume_redash_2.png","http://resume.52fx.biz/myresume_redash_1.png"],
      projectInfo: [
        {
          title: "项目1",
          intro: "这里是项目介绍",
          company: "某司",
          developEnv: "这里是开发环境介绍",
          responsibility: {
            res1: "职责1",
            res2: "职责2",
            res3: "职责3"
          }
        },
        {
          title: "项目2",
          intro: "这里是项目2介绍",
          company: "某司",
          developEnv: "这里是开发环境介绍",
          responsibility: {
            res1: "职责1",
            res2: "职责2",
            res3: "职责3"
          }
        },
        {
          title: "项目3",
          intro: "这里是项目3介绍",
          company: "某司",
          developEnv: "这里是开发环境介绍",
          responsibility: {
            res1: "职责1",
            res2: "职责2",
            res3: "职责3"
          }
        }
      ]
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    drawerHander(index) {
      this.drawer = true;
      this.currentIndex = index - 1;
    }
  }
};
</script>
<style>
div .el-divider--horizontal {
  height: 2px;
  margin-top: 100px;
  background-color: rgb(84, 92, 100);
}
div .el-divider__text {
  font-size: 26px;
  color: #545c64;
}
div .el-drawer__header {
  font-size: 20px;
  font-weight: blod;
  padding-bottom: 20px;
  border-bottom: 1px solid;
}
div .el-drawer {
  background-color: rgb(61, 67, 72);
  color: #ccc;
}
div .el-drawer__body {
  padding: 0px 20px 0px 20px;
}
</style>
<style scoped>
.aboutus .grid-content.line {
  border-right: 1px solid #ddd;
  height: 150px;
}
.aboutus .el-card__header {
  background: #545c64;
}
.aboutus .el-card__body {
  padding: 50px 20px;
}
.aboutus .el-timeline-item__wrapper {
  top: -8px;
}
.aboutus .title p .el-tag {
  margin: 0px 5px;
  cursor: pointer;
}
@media screen and (min-width: 400px) and (max-width: 768px) {
  .aboutus{
    font-size: 14px;
    text-align: left;
    padding: 0px 20px;
  }
}
@media screen and (min-width: 1024px) {
  .aboutus{
    font-size: 14px;
    text-align: left;
    padding: 0px 100px;
  }
}
  .intro{
    width: 200px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .text {
    font-size: 14px;
    text-align: left;
    line-height: 30px;
    text-indent: 2em;
  }
  .box-card{
    position: relative;
  }
  .item {
    display: inline-block;
    margin: 30px 50px;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  .clearfix span{
    color: #fff;
    font-weight: bold;
  }
  .title p{
    color: #8c8888;
    font-size: 15px;
    margin-bottom: 80px;
    text-align: center;
  }
  .grid-content .large{
    font-size: 16px;
    color: #409EFF;
    font-weight: bold;
  }
  .topMask{
    width: 100px;
    height: 100px;
    background-color: rgba(68,138,255,0.2);
    transform: rotate(45deg);
    position: absolute;
  }
  .square{
    border-radius: 5px;
    top: 0px;
  }
  .circular{
    border-radius: 50%;
    top:80px;
    left: 80%;
    background-color: rgba(255, 208, 75,0.2);
  }
</style>


// WEBPACK FOOTER //
// src/components/history/Index.vue